<template>
  <div class="News" style="zoom:80%">
    <!-- <div class="news_banner"><h3>获取一手新鲜资讯，了解我们</h3></div> -->
    <div class="wrap">
    <!--   <swiper class="news_swiper" style="zoom:80%" :options="swiperOption" ref="mySwiper">
        <swiper-slide> 
          <router-link to="newsdetails/8" class="flex">
          <div class="img">
            <img src="../assets/img/news/detail/81.png" />
            <p>八月专题新闻</p>
          </div>
        </router-link>
        </swiper-slide>
        <swiper-slide style="display: flex;justify-content: center;align-items: center;">
          <router-link to="newsdetails/6" class="flex">
          <div  class="img">
            <img src="../assets/img/news/detail/61.png" />
            <p>六月专题新闻</p>
          </div>
        </router-link>
        </swiper-slide>
        <div class="swiper-pagination " slot="pagination"></div>
      </swiper> -->
      <div class="page_tit_news">
        {{ $t("news.latestnew") }}
      </div>
      <ul class="news_list">
        <li v-for="item in List" :key="item">
          <router-link :to="'/newsdetails/' + item.id" class="flex">
            <div class="img"><img :src="item.img"/></div>
            <div class="text">
              <div class="txt">
                <p v-if="language == 'zh'"  v-html="item.text2"></p>
                <p v-if="language == 'en'"  v-html="item.text2en"></p>
              </div>
              <div class="des">
                <span  v-if="language == 'zh'" v-html="item.title"></span>
                <span  v-if="language == 'en'" v-html="item.titleen"></span>
                <span v-html="item.publishdate"></span>
              </div>
            </div>
          </router-link>
        </li>
      </ul>
      <div class="ht50"></div>
      <div class="more_news"><a href="#">{{ $t("news.morenews") }}</a></div>
      <div class="ht50"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      swiperOption: {
        loop: true,
        language: "",
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        on: {
          slideChangeEnd: function() {},
        },
      },
      List: [
      {
          id: 12,
          img: "detail/2025102501.jpg",
          title: "十月专题新闻",
          titleen: "October Features",
          publishdate: "2025.10.25",
          text2:"十月二十四号，应中国上海市杨浦区政府的邀请，UC-ELINK公司CEO钱峰先生参加了在剑桥...",
          text2en:"On October 24, upon the invitation of the Yangpu District Government of Shanghai, China, Mr. Qian Feng,.....",
      },
      {
          id: 11,
          img: "detail/20250501.jpg",
          title: "四月专题新闻",
          titleen: "April Features",
          publishdate: "2025.4.12",
          text2:"UC-ELINK持续推动中英之间高端人才交流，四月十至十一日，再次作为协办单位推动由华威大学...",
          text2en:"Recently, Mr. Qian Feng, CEO of UC-ELINK Company, met with Ms. Song Qian, ....",
      },
      {
          id: 10,
          img: "detail/101.jpg",
          title: "三月专题新闻",
          titleen: "March Features",
          publishdate: "2025.3.30",
          text2:"近日，UC-ELINK公司CEO钱峰先生在上海拜会了知名猎头公司翰德（Hudson）总经理宋倩女士和...",
          text2en:"Recently, Mr. Qian Feng, CEO of UC-ELINK Company, met with Ms. Song Qian, ....",
      },
      {
          id: 9,
          img: "detail/92.jpg",
          title: "二月专题新闻",
          titleen: "February Features",
          publishdate: "2025.2.10",
          text2:"二月八日，应伦敦华人金融家协会的邀请，UC-ELINK公司CEO钱峰先生参加了协会在剑桥大学...",
          text2en:"On February 8th, at the invitation of the Chinese Financialists Association in London....",
      },
      {
          id: 8,
          img: "detail/81.png",
          title: "八月专题新闻",
          titleen: "August Features",
          publishdate: "2024.8.2",
          text2:"UC-ELINK推动中英之间高端人才交流，于八月十四至十五日，协助推动由华威大学副校长，...",
          text2en:"UC-ELINK has played a key role in promoting high-end talent exchange between China and the UK. On August...",
      },
      {
          id: 6,
          img: "detail/61.png",
          title: "六月专题新闻",
          titleen: "June Features",
          publishdate: "2024.7.2",
          text2:"UC-ELINK和中国本土最大猎头公司嘉驰国际合作，正式推出中国留学生一对一择业...",
          text2en:"UC-ELINK has partnered with X-GIANTS, the largest headhunting firm in China, to officially launch one-on-one ...",  
     },
      {
          id: 5,
          img: "detail/51.png",
          title: "五月专题新闻",
          titleen: "May Features",
          publishdate: "2024.6.2",
          text2:
            "UC-ELINK和英国最大的留学生社群红杉学社建立战略合作关系，双方将在人才服务，...",
          text2en:"UC-ELINK has established a strategic partnership with Redwood Academy, the largest international student...",  
        },
      {
          id: 3,
          img: "detail/31.png",
          title: "三月专题新闻",
          titleen: "March Features",
          publishdate: "2024.4.3",
          text2:
            "UC-ELINK和中国本土最大猎头公司嘉驰国际建立战略合作关系，双方将合作，将针...",
          text2en:"UC-ELINK has established a partnership with X-GIANTS, China’s largest headhunting firm, to offer personalized...",  
        },
      {
          id: 2,
          img: "detail/2.png",
          title: "二月专题新闻",
          titleen: "February Features",
          publishdate: "2024.3.1",
          text2:
            "UC-ELINK和中国人力资源行业领先媒体公司HRoot建立战略合作关系，双方将在人...",
          text2en:"UC-ELINK has partnered with HRoot, a leading Chinese human resources company, to collaborate on talent ...",  
        },
        {
          id: 1,
          img: "detail/1.png",
          title: "一月专题新闻",
          titleen: "January Features",
          publishdate: "2024.2.6",
          text2:
            "UC-ELINK和全球知名猎头公司Hudson建立战略合作关系。双方将着眼于人才服务领...",
          text2en:"UC-ELINK has established a partnership with the well-known headhunting firm Hudson. Together, they will focus...",  
        }, 
      ]
    };
  },
  computed: {
    ProList() {
      return [
        {
          img: require("../assets/img/contactus/picture2.jpg"),
          tit: this.$t("others.kouhao"),
          des: "",
        },
      ];
    },
  },
  components: {},
  created() {
    this.language = this.$i18n.locale;
  },
  computed: {
    language2() {
      return this.$i18n.locale;
    },
  },
  watch: {
    language2: function(a, b) {
      this.language=a
    },
  },
  mounted() {
    this.language = this.$i18n.locale;
  },
};
</script>

<style lang="scss" scoped></style>
